import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  LinearProgress,
  Alert,
  Snackbar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Typography,
  Box,
  Button,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DescriptionIcon from "@mui/icons-material/Description";
import DownloadIcon from "@mui/icons-material/Download";
import { ApiHook } from "../../hooks/apiHook";
import * as XLSX from "xlsx-js-style";

const AddImport = () => {
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [showErrorPreview, SetshowErrorPreview] = useState({
    show: false,
    content: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [errorData, setErrorData] = useState();
  const Upload = ApiHook.CalluploadExcel(File);

  const onDownloadErrorReport = () => {
    if (errorData) {
      const worksheet = XLSX.utils.json_to_sheet(errorData);

      // Initialize columns if not exists
      if (!worksheet["!cols"]) worksheet["!cols"] = [];

      // Apply styling to error cells
      errorData.forEach((row, rowIndex) => {
        Object.entries(row).forEach(([key, val]) => {
          if (key !== "Row Number" && key !== "Errors" && val.hasError) {
            const cellRef = XLSX.utils.encode_cell({
              r: rowIndex + 1, // +1 for header row
              c: Object.keys(row).indexOf(key),
            });

            // Only style if cell exists
            if (worksheet[cellRef]) {
              worksheet[cellRef].s = {
                fill: { fgColor: { rgb: "FFFF0000" } }, // Red background
                font: { bold: true, color: { rgb: "FFFFFFFF" } }, // White bold text
              };
            }
          }
        });
      });

      // Create workbook and save
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Errors");

      XLSX.writeFile(workbook, `errors-${Date.now()}.xlsx`);
    }
  };

  const ExportExcel = () => {
    const reportHeader = [
      "First Name",
      "Last Name",
      "Email",
      "Mobile",
      "Country",
      "Leader",
      "Entrepreneur",
      "Teachable",
      "Solvent",
      "Urgency",
      "Client",
      "Description",
    ];

    const reportData = [
      {
        firstname: "John",
        lastname: "Deo",
        email: "johndeo@gmail.com",
        mobile: "+913425657",
        country: "IND",
        leader: "x",
        entrepruner: "",
        teachable: "x",
        solvent: "x",
        urgency: "A",
        client: "x",
        description: "This is a potential client",
      },
      {
        firstname: "James",
        lastname: "Deo",
        email: "james@gmail.com",
        mobile: "+87675454",
        country: "CCK",
        leader: "x",
        entrepruner: "",
        teachable: "x",
        solvent: "",
        urgency: "A",
        client: "x",
        description: "This is a potential client",
      },
    ];

    const instructions = [
      ["LEAD IMPORT TEMPLATE INSTRUCTIONS"],
      [""],
      ['1. Fill in the "Leads" sheet with your data'],
      ["2. Required fields: First Name, Mobile, Email", "Country"],
      ["3. Other fields are optional"],
      ["4. Do not modify the column headers"],
      ["5. Make sure you give the country code in ISO format"],
      ["6. Save the file and upload it to the system"],
      [""],
      ["TROUBLESHOOTING"],
      ["- Provide valid Email, Mobile, Country"],
      ["- Remove any empty rows"],
      ["- Save as .xlsx format"],
    ];

    const leadsData = reportData.map((item) => [
      item.firstname,
      item.lastname,
      item.email,
      item.mobile,
      item.country,
      item.leader,
      item.solvent,
      item.entrepruner,
      item.teachable,
      item.urgency,
      item.client,
      item.description,
    ]);

    // Create workbook
    const wb = XLSX.utils.book_new();

    const leadsSheet = XLSX.utils.aoa_to_sheet([reportHeader, ...leadsData]);

    const totalRows = leadsData.length + 1; // +1 for header row
    const totalColumns = reportHeader.length;

    leadsSheet["!rows"] = Array.from({ length: totalRows }, (_, i) => ({
      hpt: 20 + i * 8,
    }));
    leadsSheet["!cols"] = Array.from({ length: totalColumns }, (_, i) => ({
      wpx: 80 + i * 30,
    }));

    const range = XLSX.utils.decode_range(leadsSheet["!ref"]);
    for (let col = range.s.c; col <= range.e.c; ++col) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
      const cell = leadsSheet[cellAddress];

      cell.s = {
        fill: {
          type: "pattern",
          pattern: "solid",
          fgColor: { rgb: "32CD32" }, // 🌿 Light Green
        },
        font: {
          bold: true,
          sz: 9,
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } },
        },
      };
    }
    for (let row = range.s.r + 1; row <= range.e.r; ++row) {
      for (let col = range.s.c; col <= range.e.c; ++col) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (leadsSheet[cellAddress]) {
          leadsSheet[cellAddress].s = {
            alignment: {
              horizontal: "center",
              vertical: "center",
            },
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    }

    XLSX.utils.book_append_sheet(wb, leadsSheet, "Leads");

    const instructionSheet = XLSX.utils.aoa_to_sheet(instructions);

    instructionSheet["!rows"] = Array(instructions.length).fill({ hpt: 30 });
    instructionSheet["!cols"] = Array(instructions.length).fill({ wpx: 100 });
    XLSX.utils.book_append_sheet(wb, instructionSheet, "Instructions");
    XLSX.writeFile(wb, "leads_import_template.xlsx");
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      setFile(acceptedFiles[0]);
    },
  });

  const handleUpload = async () => {
    if (!file) {
      showSnackbar("Please select a file first", "error");
      return;
    }
    SetshowErrorPreview({
      show: false,
      content: "",
    });
    console.log("file", file);
    const formData = new FormData();
    formData.append("file", file);

    try {
      setIsUploading(true);
      setUploadProgress(0);

      Upload.mutate(file, {
        onSuccess: (response) => {
          console.log(response);
          if (response.status) {
            SetshowErrorPreview({
              show: false,
              content: "",
            });
            setUploadProgress(100);
            showSnackbar(
              response.data.message || "Upload successful",
              "success"
            );
          } else {
            
            if (response?.message == "INVALID_DATA_FOUND") {
              console.log("response",response)
              SetshowErrorPreview({
                show: true,
                content: response?.description,
              });
              setErrorData(response?.description?.errorReportUrl);
              showSnackbar("Invalid data detected in the file.", "error");
            }
            else{
             showSnackbar(response?.data?.description, "error");
            }

            
          }
        },
        onError: (error) => {
          showSnackbar(
            error.response?.data?.message || "Upload failed",
            "error"
          );

          setUploadProgress(0);
        },
        onSettled: () => {
          setIsUploading(false);
          setTimeout(() => setUploadProgress(0), 2000);
        },
      });
    } catch (error) {
      // This catch block will only handle errors outside the mutation
      showSnackbar("An unexpected error occurred", "error");
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      <div className="page_head_top">Add Lead</div>
      <div className="frm-content">
        <div className="p-3">
          <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
            <Typography
              variant="h4"
              gutterBottom
              sx={{ mb: 4, fontWeight: "bold" }}
            >
              Excel Data Importer
            </Typography>

            <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Upload Excel File
              </Typography>

              <Box
                {...getRootProps()}
                sx={{
                  border: "2px dashed",
                  borderColor: isDragActive ? "primary.main" : "grey.400",
                  borderRadius: 1,
                  p: 4,
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: isDragActive
                    ? "action.hover"
                    : "background.paper",
                  mb: 2,
                }}
              >
                <input {...getInputProps()} />
                <CloudUploadIcon
                  sx={{ fontSize: 48, color: "#954cea", mb: 1 }}
                />
                <Typography>
                  {isDragActive
                    ? "Drop the Excel file here"
                    : "Drag & drop an Excel file here, or click to select"}
                </Typography>
              </Box>
              {file && (
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <DescriptionIcon sx={{ mr: 1 }} />
                  <Typography variant="body1">
                    {file.name} ({Math.round(file.size / 1024)} KB)
                  </Typography>
                  <Button
                    size="small"
                    onClick={() => setFile(null)}
                    sx={{ ml: "auto" }}
                  >
                    Remove
                  </Button>
                </Box>
              )}

              {isUploading && (
                <Box sx={{ width: "100%", mb: 2 }}>
                  <LinearProgress
                    variant="determinate"
                    value={uploadProgress}
                    sx={{ height: 8 }}
                  />
                  <Typography
                    variant="caption"
                    sx={{ textAlign: "right", display: "block" }}
                  >
                    {uploadProgress}% Complete
                  </Typography>
                </Box>
              )}
              <Box
                sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}
              >
                <Tooltip title="Download Excel template with required format">
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<DownloadIcon />}
                    onClick={() => {
                      ExportExcel();
                    }}
                    sx={{ mr: 2 }}
                  >
                    Download Template
                  </Button>
                </Tooltip>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpload}
                  disabled={!file || isUploading}
                  startIcon={
                    isUploading ? <CircularProgress size={20} /> : null
                  }
                  sx={{ mt: 1 }}
                >
                  {isUploading ? "Uploading..." : "Upload File"}
                </Button>
              </Box>
            </Paper>

            {/* Preview & Error Report Section */}
            {showErrorPreview?.show && (
              <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Typography variant="h6">Validation Results</Typography>
                  {/* <Button
                    onClick={() => setValidationResult(null)}
                    startIcon={<CloseIcon />}
                  >
                    Clear Results
                  </Button> */}
                </Box>

                {/* Stats Summary */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    mb: 3,
                    "& > *": {
                      p: 2,
                      borderRadius: 1,
                      textAlign: "center",
                      flex: 1,
                    },
                  }}
                >
                  <Paper variant="outlined">
                    <Typography variant="subtitle2">Total Records</Typography>
                    <Typography variant="h6">
                      {showErrorPreview?.content?.stats.totalRecords}
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{ borderColor: "success.light" }}
                  >
                    <Typography variant="subtitle2">Valid</Typography>
                    <Typography variant="h6" color="success.main">
                      {showErrorPreview?.content?.stats.validCount}
                    </Typography>
                  </Paper>
                  <Paper variant="outlined" sx={{ borderColor: "error.light" }}>
                    <Typography variant="subtitle2">Errors</Typography>
                    <Typography variant="h6" color="error.main">
                      {showErrorPreview?.content?.stats.errorCount}
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    mt: 3,
                    alignItems: "center",
                  }}
                >
                  {showErrorPreview?.content?.errorReportUrl && (
                    <>
                      <Box sx={{ p: 2 }}>
                        <Typography variant="subtitle2" color="error">
                          ↓ Download the report below to see all errors and make
                          corrections
                        </Typography>
                        <Typography variant="subtitle2" color="error">
                          ↓ Save the corrected file
                        </Typography>
                        <Typography variant="subtitle2" color="error">
                          ↓ Upload the same file again using the upload area
                        </Typography>
                        <Box
                          component="a"
                          onClick={() =>
                            onDownloadErrorReport(
                              showErrorPreview?.content?.errorReportUrl
                            )
                          }
                          //href={showErrorPreview?.content?.errorReportUrl}
                          download="Error_Report.xlsx"
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            px: 3,
                            py: 1,
                            border: "1px solid",
                            borderColor: "secondary.main",
                            borderRadius: 1,
                            color: "secondary.main",
                            textDecoration: "none",
                            "&:hover": {
                              backgroundColor: "action.hover",
                              textDecoration: "none",
                            },
                          }}
                        >
                          <DownloadIcon sx={{ mr: 1 }} />
                          Download Error Report
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
              </Paper>
            )}
            <Snackbar
              open={snackbar.open}
              autoHideDuration={6000}
              onClose={handleCloseSnackbar}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert
                onClose={handleCloseSnackbar}
                severity={snackbar.severity}
                sx={{ width: "100%" }}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>
          </Box>
        </div>
      </div>
    </>
  );
};

export default AddImport;
